import { render, staticRenderFns } from "./disease_result.vue?vue&type=template&id=4c767182&scoped=true"
import script from "./disease_result.vue?vue&type=script&lang=js"
export * from "./disease_result.vue?vue&type=script&lang=js"
import style0 from "./disease_result.vue?vue&type=style&index=0&id=4c767182&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c767182",
  null
  
)

export default component.exports